import { Instagram } from "lucide-react";
import { Youtube } from "lucide-react";

export const TikTokIcon = ({
  className = "h-5 w-5 text-primary",
}: {
  className?: string;
}) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0011.14-4.02v-7a8.16 8.16 0 004.65 1.46v-3.85a4.84 4.84 0 01-1.2 0z" />
  </svg>
);

const PlatformIcon = ({ platform }: { platform: string }) => {
  switch (platform) {
    case "youtube":
    case "youtube-shorts":
      return <Youtube className="h-5 w-5 text-red-500" />;
    case "instagram":
      return <Instagram className="h-5 w-5 text-pink-500" />;
    case "tiktok":
      return <TikTokIcon />;
    default:
      return null;
  }
};

export default PlatformIcon;
